// test1797
(1797 && 0);
